module.exports = __webpack_public_path__ + "static/media/32-3.367aca7f.mp3";